export type Bonus = {
  number: number;
  title: string;
  description: string;
  listIntro: string;
  list: string[];
  flow: string[];
};

export const bonuses: Bonus[] = [
  {
    number: 1,
    title: 'Atlas Visual de Detalles Constructivos',
    description: 'Una biblioteca visual para explicar encuentros, capas, componentes y soluciones constructivas.',
    listIntro: 'Incluye referencias sobre:',
    list: [
      'fundaciones',
      'muros',
      'losas',
      'estructuras',
      'cubiertas',
      'aislaciones',
      'impermeabilización',
      'aberturas',
      'pisos',
      'terminaciones',
    ],
    flow: ['Observá', 'Interpretá', 'Relacioná', 'Explicá'],
  },
  {
    number: 2,
    title: 'Diccionario Técnico de Construcción',
    description: 'El vocabulario esencial de planos, obra y documentación explicado de forma clara y fácil de consultar.',
    listIntro: 'Incluye conceptos relacionados con:',
    list: [
      'materiales',
      'estructuras',
      'mampostería',
      'instalaciones',
      'cubiertas',
      'terminaciones',
      'seguridad',
      'cómputo',
      'planificación',
    ],
    flow: ['Buscá', 'Comprendé', 'Relacioná', 'Aplicá'],
  },
  {
    number: 3,
    title: 'Errores Frecuentes en Obra y Cómo Detectarlos',
    description: 'Una guía para enseñar a observar problemas habituales y analizar sus posibles causas.',
    listIntro: 'Incluye situaciones relacionadas con:',
    list: [
      'replanteo',
      'mampostería',
      'humedad',
      'hormigón',
      'cubiertas',
      'impermeabilización',
      'terminaciones',
      'aberturas',
      'coordinación de instalaciones',
    ],
    flow: ['Observá', 'Detectá', 'Analizá', 'Prevení'],
  },
  {
    number: 4,
    title: 'Guía de Lectura e Interpretación de Planos',
    description: 'Un método práctico para aprender qué mirar, en qué orden y cómo relacionar distintos documentos técnicos.',
    listIntro: 'Trabajá con:',
    list: [
      'plantas',
      'cortes',
      'vistas',
      'cotas',
      'escalas',
      'niveles',
      'planos estructurales',
      'instalaciones',
      'detalles',
      'coordinación de documentación',
    ],
    flow: ['Identificá', 'Ubicá', 'Interpretá', 'Verificá'],
  },
  {
    number: 5,
    title: 'Banco de Casos Prácticos de Construcción',
    description: 'Situaciones reales y simuladas para convertir la teoría en análisis técnico.',
    listIntro: 'Los estudiantes deberán:',
    list: [
      'observar',
      'interpretar',
      'detectar problemas',
      'comparar alternativas',
      'proponer decisiones',
      'justificar respuestas',
    ],
    flow: ['Observar', 'Analizar', 'Decidir', 'Justificar'],
  },
];
